import React, { useEffect, useRef } from 'react';
import { FaCloudDownloadAlt } from 'react-icons/fa';

import { ButtonWithIcon } from '../../../components/ButtonWithIcon';
const ReactExport: any = require('react-export-excel-xlsx-fix');

const ExcelFile = ReactExport.modules.ExcelFile;
const ExcelSheet = ReactExport.modules.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.modules.ExcelFile.ExcelColumn;

const dataSetExample = [
    {
        email: "test@bevi.com",
        program: "Bevi",
        group: "Bevi Group",
    },
];

export const ExcelTemplate = (): JSX.Element => {
    return (
        <ExcelFile
            element={
                <ButtonWithIcon
                    key={'btn'}
                    textId={'app.create.user.download.data.example'}
                    icon={<FaCloudDownloadAlt />}
                />}>
            <ExcelSheet data={dataSetExample} name="Sheet1">
                <ExcelColumn label="Email" value="email" />
                <ExcelColumn label="Program" value="program" />
                <ExcelColumn label="Group" value="group" />
            </ExcelSheet>
        </ExcelFile>
    );
}

export const ExcelTemplateDownload = ({ dataSetExample }: { dataSetExample: any[] }): JSX.Element => {
    const downloadRef = useRef<HTMLAnchorElement>(null);

    console.log(dataSetExample)

    useEffect(() => {
        if (downloadRef.current) {
            downloadRef.current.click();
        }
    }, []);

    return (
        <ExcelFile
            element={
                // eslint-disable-next-line jsx-a11y/anchor-is-valid
                <a ref={downloadRef} style={{ display: 'none' }}>
                    Download
                </a>
            }
        >
            <ExcelSheet data={dataSetExample} name="Sheet1">
                <ExcelColumn label="Email" value="email" />
                <ExcelColumn label="Program" value="program" />
                <ExcelColumn label="Group" value="group" />
                <ExcelColumn label="Errors" value="errors" />
            </ExcelSheet>
        </ExcelFile>
    );
}
